const steps = [
  {
    icon: "ri-search-line",
    title: "Busque seu veículo",
    description: "Use nossa busca avançada para encontrar o veículo ideal por tipo, preço e disponibilidade em Campinas.",
    step: "01",
  },
  {
    icon: "ri-smartphone-line",
    title: "Baixe o app",
    description: "Faça seu cadastro gratuito no app da LocaCar. Sem burocracia, sem entrada, 100% digital.",
    step: "02",
  },
  {
    icon: "ri-car-line",
    title: "Retire o veículo",
    description: "Vá até a agência escolhida e retire seu veículo. Tudo aprovado pelo app com segurança.",
    step: "03",
  },
  {
    icon: "ri-secure-payment-line",
    title: "Pague pelo app",
    description: "A fatura é gerada e paga exclusivamente pelo app da loja. Simples, seguro e transparente.",
    step: "04",
  },
];

export default function HowItWorks() {
  return (
    <section id="como-funciona" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="text-orange-500 text-sm font-semibold uppercase tracking-widest">Simples assim</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-1">Como Funciona</h2>
          <p className="text-gray-500 mt-2 max-w-xl mx-auto">
            Alugar um veículo em Campinas nunca foi tão fácil. Sem entrada, sem burocracia.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, idx) => (
            <div key={idx} className="relative flex flex-col items-center text-center group">
              {/* Connector line */}
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[calc(50%+40px)] right-[-calc(50%-40px)] h-px bg-orange-200 z-0 w-full"></div>
              )}
              {/* Icon */}
              <div className="relative z-10 w-20 h-20 flex items-center justify-center rounded-2xl bg-white border-2 border-orange-100 group-hover:border-orange-400 group-hover:bg-orange-50 transition-all mb-5">
                <i className={`${step.icon} text-3xl text-orange-500`}></i>
                <span className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center bg-orange-500 text-white text-xs font-extrabold rounded-full">
                  {step.step}
                </span>
              </div>
              <h3 className="font-bold text-gray-900 text-base mb-2">{step.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
